import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { FakeText, Accordion, Card, Typography } from '@totalsoft/rocket-ui';
import EngineScoringClassificationListItemComponent from './EngineScoringClassificationListItemComponent';
import Font from '@mui/icons-material/FormatListNumberedRtlSharp';
import { getErrors } from '@totalsoft/pure-validations-react';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { IconButton } from '@totalsoft/rocket-ui';

const EngineScoringClassificationListComponent = ({
  engineScoringId,
  classifications,
  onSave,
  isReadOnly,
  dispatch,
  validation,
  loading,
  scoringCategoryOptions,
  dictionaryApplicationPage,
  dictionaryScoringResponseState,
  engineAttributeOptions,
  scoringFinancialIndicatorOptions,
  useAllAttributes,
  evaluatedAttributes
}) => {
  const { t } = useTranslation();
  const onAddNewClassification = () => {
    dispatch({
      type: 'OnAddNewClassification'
    });
  };

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <Card
      icon={Font}
      iconColor='primary'
      title={t('EngineScoring.EngineClassifications.Title')}
      actions={
        <IconButton
          type='add'
          fontSize='medium'
          tooltip={t('Tooltips.EngineScoringGrid.AddClassification')}
          onClick={onAddNewClassification}
          color='transparent'
          disabled={isReadOnly}
        />
      }
    >
      <CardNoResultsWrapper content={classifications}>
        <Grid container spacing={1} sx={{ padding: '10px' }}>
          {classifications.length > 0 && (
            <Accordion
              sx={{ mb: 2, width: 1 }}
              content={classifications.map((sc, idx) => {
                return {
                  title: sc.engineScoringClassificationName,
                  content: (
                    <EngineScoringClassificationListItemComponent
                      engineScoringId={engineScoringId}
                      isReadOnly={isReadOnly}
                      scoringClassification={sc}
                      dispatch={dispatch}
                      engineClassificationIndex={idx}
                      onSave={onSave}
                      collectionValidation={validation}
                      scoringCategoryOptions={scoringCategoryOptions}
                      dictionaryApplicationPage={dictionaryApplicationPage}
                      dictionaryScoringResponseState={dictionaryScoringResponseState}
                      engineAttributeOptions={engineAttributeOptions}
                      scoringFinancialIndicatorOptions={scoringFinancialIndicatorOptions}
                      useAllAttributes={useAllAttributes}
                      evaluatedAttributes={evaluatedAttributes}
                    />
                  )
                };
              })}
            />
          )}
        </Grid>
      </CardNoResultsWrapper>
      <Grid container>
        <Grid item xs={10}>
          <Typography color='error'>{validation |> getErrors}</Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

EngineScoringClassificationListComponent.propTypes = {
  classifications: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  engineScoringId: PropTypes.number,
  isReadOnly: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  scoringCategoryOptions: PropTypes.array.isRequired,
  dictionaryApplicationPage: PropTypes.array.isRequired,
  dictionaryScoringResponseState: PropTypes.array.isRequired,
  engineAttributeOptions: PropTypes.array.isRequired,
  scoringFinancialIndicatorOptions: PropTypes.array.isRequired,
  useAllAttributes: PropTypes.bool.isRequired,
  evaluatedAttributes: PropTypes.array.isRequired
};

export default EngineScoringClassificationListComponent;
